import { ReachAPI } from './ReachAPI';
import { Log } from '../AuxillaryService/Log';

/**
 * @class announcement
 * @hideconstructor
 * @memberof ReachAPI
 */
ReachAPI.announcement = {};

/**
 * GET Endpoint `/announcement/list2`
 * @param facility_id
 * @param screen_id
 * @param last_hash
 * @param {Array} [statuses]
 * @param {ReachAPI.Security} security Currently unused, but is here to have
 * parity with getList function
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.announcement
 * @deprecated Legacy Announcements (`/announcement/list2/`) have been superseded by Media Playlists
 * (`/media/playlist/signage/`).
 */
ReachAPI.announcement.getLegacyList = function (
    facility_id,
    screen_id,
    last_hash,
    statuses,
    // eslint-disable-next-line no-unused-vars
    security
) {
    statuses = statuses || [];

    var cache_id = '/announcement/list/facility=' + facility_id + '/screen=' + screen_id;
    var url =
        ReachAPI.server + '/announcement/list2/' + facility_id + '/' + screen_id + '/' + last_hash;
    var params = {
        statuses: statuses,
    };
    var jqPromise;

    jqPromise = ReachAPI.getAndUpdateCached(
        url,
        'json',
        params,
        cache_id,
        function (oldCachedContent, newApiContent) {
            var oldCachedHash = oldCachedContent.hash || null;
            var newApiHash = newApiContent.hash || null;

            if (newApiHash !== null && newApiHash !== oldCachedHash) {
                Log.Info('Retrieved new Announcements from the API', null, __fileline);
                return newApiContent;
            } else {
                return oldCachedContent;
            }
        }
    );

    jqPromise.done(function (data, textStatus) {
        // Only log on first call
        if (last_hash === 0) {
            if (textStatus === 'cache') {
                Log.Debug(
                    'Retrieved Announcements from the CACHE (API call failed)',
                    null,
                    __fileline
                );
            } else {
                Log.Debug('Retrieved Announcements from the API', null, __fileline);
            }
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve Announcements',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};

/**
 * GET Endpoint `/media/playlist/signage`
 * @param facility_id
 * @param screen_id
 * @param last_hash
 * @param {Array} [statuses]
 * @param {ReachAPI.Security} security
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.announcement
 */
ReachAPI.announcement.getList = function (facility_id, screen_id, last_hash, statuses, security) {
    statuses = statuses || [];

    var cache_id = '/announcement/list/facility=' + facility_id + '/screen=' + screen_id;
    var url = ReachAPI.server + '/media/playlist/signage/';
    var params = {
        playlist_id: screen_id,
        facility_id: facility_id,
        lastquery: last_hash,
        statuses: statuses,
    };
    var jqPromise;

    params = security.merge(params);

    jqPromise = ReachAPI.getAndUpdateCached(
        url,
        'json',
        params,
        cache_id,
        function (oldCachedContent, newApiContent) {
            var oldCachedHash = oldCachedContent.hash || null;
            var newApiHash = newApiContent.hash || null;

            if (newApiContent.errors.length > 0) {
                Log.Error(
                    'Announcements returned with errors',
                    null,
                    __fileline,
                    newApiContent.errors
                );
            }

            if (newApiHash !== null && newApiHash !== oldCachedHash) {
                Log.Info('Retrieved new Announcements from the API', null, __fileline);
                return newApiContent;
            } else {
                return oldCachedContent;
            }
        }
    );

    jqPromise.done(function (data, textStatus) {
        // Only log on first call
        if (last_hash === 0) {
            if (textStatus === 'cache') {
                Log.Debug(
                    'Retrieved Announcements from the CACHE (API call failed)',
                    null,
                    __fileline
                );
            } else {
                Log.Debug('Retrieved Announcements from the API', null, __fileline);
            }
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve Announcements',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};
